import type {
  UserCreateVariables,
  UserEntity,
  UserUpdateVariables,
} from "./user.type";
import type { UseCreateOptions, UseUpdateOptions } from "@/hooks/queries";

import { useCreate, useUpdate } from "@/hooks/queries";

export const useCreateUser = (
  options?: UseCreateOptions<UserEntity, UserCreateVariables>
) => {
  return useCreate<UserEntity, UserCreateVariables>("users", options);
};

export const useUpdateUser = (
  userId: number,
  options?: UseUpdateOptions<UserEntity, UserUpdateVariables>
) => {
  return useUpdate<UserEntity, UserUpdateVariables>("users", userId, options);
};
